export class Hamburger {
	private toggleClass = 'is-active';

	constructor(private element: HTMLElement) {
		const hamburgerButton = this.element.getElementsByClassName('js-hamburger-toggler');
		if (hamburgerButton && hamburgerButton.length) {
			hamburgerButton[0].addEventListener('click', () => {
				this.element.classList.toggle(this.toggleClass)
			});
		}
	}
}
